module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-02-f5ef71b25b0d812e455881afec5daa01.jpg";